import React, { useState } from "react";
import "./Account.css";
import { Container } from "react-bootstrap";
import { RiArrowDropDownLine } from "react-icons/ri";
import Footer from '../Footer/Footer';
import TracerSidebar from "../Sidebar/TracerSidebar";
import Accountnav from "../Navbar/Accountnav";
import { Link } from "react-router-dom";

const Account = () => {
  const [toggleState, setToggleState] = useState(1);
  const [isActive, setActive] = useState(false)

  const toggleClass = () =>{
    setActive(!isActive);
  }
  
  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <>
      <div className="App">
        <div className="side-bar ">
          < TracerSidebar handleClick={toggleClass} isActive={isActive}/>
        </div>
        <div className="main w-100">
          <Accountnav isActive={isActive}/>
          <Container>
            <div className="billing-head">
             <div className="manage-btn">
               <ul className="ul-btn">
                 <li  className={toggleState === 1 ? "btn-li active-btn-li" : "btn-li"}
                onClick={() => toggleTab(1)}>
                   SETTING
                 </li>
                 <Link to="/billing">
                 <li className={toggleState === 2 ? "btn-li active-btn-li" : "btn-li"}
                onClick={() => toggleTab(2)}>
                   BILLING
                 </li>
                 </Link>
               </ul>
             </div>
              <div className="account-main">
                <div className="manage-title">User Management</div>
             <div className="billing-plan  col-lg-12">
                 <div className="plan  col-12 col-lg-12">
        
                     <div className="plan-box account-box">
                         <div className="plan-location">
                            <div className="account-sub-title">
                                Invite User
                            </div>
                            <div className="account-form">
                                <form action="">
                                    <div className="account-feild d-flex align-items-center">
                                        <input type="text" placeholder="admin@mail.com" />
                                        <div className="form-btn">
                                            <button>Admin <RiArrowDropDownLine className="d-icon"/></button>
                                        </div>
                                    </div>
                                </form>
                                <div className=" invite-btn">
                                            <button><span>Send invite</span></button>
                                        </div>
                            </div>
                         </div>
                         
                     </div>
                 </div>
                 <div className="plan plan2 col-lg-12">
{/*          
                 <div className="account-box">
                    <div className="workspace-title">
                        <h6>Workspaces</h6>
                    </div>
                    <div className="workspace-description">
                    workspaces are only available on the pro or Elite subscription plans
                    </div>
                 </div> */}
                 </div>
             </div>
             <div className="invoice invoice1 col-lg-12">
             <div className="account-table-title">
             Workspaces
                 </div>         
             <div className="account-table">
                 
                    <table className="table">
                      <thead>
                        <tr>
                          <th >#</th>
                          <th >Workspaces Name</th>
                          <th></th>
                          <th style={{textAlign:"end"}}>Machine Name</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td >1</td>
                          <td>John Doe</td>
                          <td></td>
                          <td>info@blacksheep.com</td>
                         
                        </tr>
                        <tr>
                          <td >2</td>
                          <td>John Doe</td>
                          <td></td>
                          <td>info@blacksheep.com</td>
                          
                        </tr>
                        <tr>
                          <td >3</td>
                          <td>John Doe</td>
                          <td></td>
                          <td>info@blacksheep.com</td>
                        
                        </tr>
                        <tr>
                          <td >3</td>
                          <td>John Doe</td>
                          <td></td>
                          <td>info@blacksheep.com</td>
                          
                        </tr>
                      </tbody>
                    </table>
                  </div>
            </div>
             <div className="invoice col-lg-12">
             <div className="account-table-title">
                     User
                 </div>         
             <div className="account-table">
                 
                    <table className="table">
                      <thead>
                        <tr>
                          <th >#</th>
                          <th >Name</th>
                          <th >Email</th>
                          <th>Phone</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td >1</td>
                          <td>John Doe</td>
                          <td>info@blacksheep.com</td>
                          <td>
                           000 1233 567 890
                          </td>
                        </tr>
                        <tr>
                          <td >2</td>
                          <td>John Doe</td>
                          <td>info@blacksheep.com</td>
                          <td>
                           000 1233 567 890
                          </td>
                        </tr>
                        <tr>
                          <td >3</td>
                          <td>John Doe</td>
                          <td>info@blacksheep.com</td>
                          <td>
                           000 1233 567 890
                          </td>
                        </tr>
                        <tr>
                          <td >3</td>
                          <td>John Doe</td>
                          <td>info@blacksheep.com</td>
                          <td>
                           000 1233 567 890
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
            </div>
              </div>
            </div>
           
          </Container>
          <Footer />
        </div>
        
      </div>
      
    </>
  );
};

export default Account;
